import { useIntl } from 'react-intl'

interface MediaLoc {
  expandImage: string
  closeImage: string
}

// Accessible labels for the zoom and close buttons on expandable question media
export const useMediaLoc = (): MediaLoc => {
  const { formatMessage } = useIntl()

  return {
    expandImage: formatMessage({
      id: 'question_expandImage',
      defaultMessage: 'Expand image'
    }),
    closeImage: formatMessage({
      id: 'question_closeImage',
      defaultMessage: 'Close'
    })
  }
}
